module.exports = __webpack_public_path__ + "img/login.b3536777.jpg";